import NamedPinnedModal from './NamedPinnedModal'

export default NamedPinnedModal
